import QueryListLookup from "./QueryListLookup";

export default QueryListLookup;
